<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active': isActive}" id="resume-list-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">이력서 불러오기</div>
      </div>
      <div class="modal-body-container">
        <div class="resume-wrap">
          <div class="resume-guide-text">
            마이페이지에서 작성한 이력서를 선택하여 지원할 수 있습니다.<br>
            <a href="/resume-list.do" target="_blank" rel="noopener noreferrer" title="새창열림">작성 이력서 보러가기</a>
          </div>
          <div class="resume-list-dropdown">
            <div class="dropdown-wrap">
              <button type="button" class="btn btn-resume-select" ref="dropdownBtn">
                <div class="title">
                  {{ seletedIdbBankInfo.displayTitle }}
                </div>
                <div class="date">
                  {{ seletedIdbBankInfo.formattedChgDate }}
                </div>
              </button>
              <div class="dropdown-list mx-ht100">
                <ul>
                  <li v-for="item in list" :key="item.indbankNo" @click="seletedIdbBank(item)">
                    <button type="button">
                      <div class="title">
                        {{ item.displayTitle }} <span v-if="item.mainResume">대표</span>
                      </div>
                      <div class="date">
                        {{ item.formattedChgDate }}
                      </div>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="update">
          수정
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'resume-list-template',
  props: ['isActive', 'appNo'],
  components: {},
  data() {
    return {
      list: [],
      seletedIdbBankInfo: {
        indbankNo: 0,
        displayTitle: '이력서를 선택하세요.',
        formattedChgDate: '-',
      },
    };
  },
  watch: {
    isActive: {
      handler(newVal) {
        if (newVal) {
          this.getList();
          this.seletedIdbBankInfo = {
            indbankNo: 0,
            displayTitle: '이력서를 선택하세요.',
            formattedChgDate: '-',
          };
        }
      },
    },
  },
  methods: {
    getList() {
      Axios.get('/api/idb/list').then((res) => {
        if (res.data.success === 'R') {
          this.list = res.data.data.data;
        }
      }).catch((error) => {
        console.log(error.data);
      });
    },
    seletedIdbBank(item) {
      this.seletedIdbBankInfo = item;
      this.$refs.dropdownBtn.click();
    },
    close() {
      this.$emit('update:closeModal', false);
    },
    update() {
      this.$emit('updateIndbankNo', this.seletedIdbBankInfo.indbankNo);
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// ResumeList.vue?13d3fb44